import { render, staticRenderFns } from "./FooterOversea.vue?vue&type=template&id=6fc7390e&"
import script from "./FooterOversea.vue?vue&type=script&lang=js&"
export * from "./FooterOversea.vue?vue&type=script&lang=js&"
import style0 from "./FooterOversea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports